<template>
  <div class="animated fadeIn mb-3">
    <b-row>
      <b-col>
        <b-form-group label="Identifier" :label-cols="2" :horizontal="true">
          <b-form-input
            type="text"
            v-model="identifier"
            placeholder="Sample Name"
            :state="!$v.identifier.$invalid"
            invalid-feedback="Required"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Harvest Date" :label-cols="2" :horizontal="true">
          <b-form-input
            type="date"
            v-model="harvest_date"
            placeholder="Sample Harvest Date"
            :state="!$v.harvest_date.$invalid"
            invalid-feedback="Required"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Field" :label-cols="2" :horizontal="true">
          <b-form-input
            type="text"
            v-model="field"
            placeholder="Sample Field"
            :state="!$v.field.$invalid"
            invalid-feedback="Required"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="pr-3" align-h="end">
      <b-col md="1.5">
        <b-button variant="success" block @click="update('duplicate')">
          <i class="fa fa-plus" /> Duplicate
        </b-button>
      </b-col>
      <template v-if="samples.length > 1">
        <b-col md="1.5" class="ml-2">
          <b-button variant="danger" block @click="update('remove')">
            <i class="fa fa-trash" /> Remove
          </b-button>
        </b-col>
      </template>
    </b-row>
    <hr />
  </div>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ProjectGeneralSampleFormGroup",
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    sampleId: {
      type: String,
      default: "",
    },
    addOns: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    sample() {
      return this.samples.find(
        (sample) => sample.test_package_sample_id === this.sampleId
      );
    },
    sample_potato() {
      return this.sample.sample_potato;
    },
    identifier: {
      get() {
        return this.sample.identifier;
      },
      set(value) {
        this.handleSampleChange(value, "identifier");
      },
    },
    harvest_date: {
      get() {
        return this.sample_potato.harvest_date;
      },
      set(value) {
        this.handleSampleChange(
          { ...this.sample_potato, harvest_date: value },
          "sample_potato"
        );
      },
    },
    field: {
      get() {
        return this.sample_potato.field;
      },
      set(value) {
        this.handleSampleChange(
          { ...this.sample_potato, field: value },
          "sample_potato"
        );
      },
    },
    isValid() {
      return this.$v && !this.$v.$invalid;
    },
  },
  validations: {
    identifier: { required },
    harvest_date: { required },
    field: { required },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION_SAMPLE"]),
    handleSampleChange(value, field) {
      this.UPDATE_SUBMISSION_SAMPLE({
        submission_id: this.submissionId,
        sample_id: this.sampleId,
        sample_update: {
          ...this.sample,
          [field]: value,
        },
      });
    },
    update(action) {
      this.$emit("updateSampleList", { action, sample_id: this.sampleId });
    },
  },
};
</script>
